import React, { useState } from 'react';
import { Autocomplete, Box, Checkbox, TextField } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

export const MonoFilterSelect = ({
  title,
  setFormData,
  dataField,
  defaultValue,
  options,
  props,
}) => {
  const [checkedItem, setCheckedItem] = useState(defaultValue || {});

  const handleChange = (selectedItem) => {
    if (!selectedItem) {
      setCheckedItem(null);
      setFormData((state) => {
        return {
          ...state,
          [dataField]: null,
        };
      });
      return;
    }

    setCheckedItem(selectedItem);
    setFormData((state) => {
      return {
        ...state,
        [dataField]: selectedItem?.id,
      };
    });
  };

  return (
    <Box sx={{ ...props, display: 'flex' }}>
      <Autocomplete
        options={options}
        disableCloseOnSelect
        getOptionLabel={(option) => (option?.label ? option?.label : '')}
        value={checkedItem}
        onChange={(event, newValue) => handleChange(newValue)}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                style={{ marginRight: 8 }}
                checked={checkedItem?.id === option?.id}
              />
              {option?.display || option?.label}
            </li>
          );
        }}
        renderValue={(option) => option?.display || option?.label}
        style={{ width: '100%' }}
        size="small"
        renderInput={(params) => <TextField {...params} label={title} />}
      />
    </Box>
  );
};
